import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { LinkActions } from '../../common/base-card-configuration';
import { MaterialConfiguration } from './material-configuration';

declare var moment: any;

export class OnlineExamCardConfiguration extends MaterialConfiguration {
    constructor(course: any, translateHandlebarsPipe: TranslateHandlebarsPipe) {
        super();
        this.tagType = 'exam';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/exam.png';
        this.classType = 'Exam';
        this.multiContent = false;
        this.subtitle = 'Online Exam';
        this.expired = !course.enabled;
        this.clickable = false;
        this.action = LinkActions.DOWNLOAD;
        this.links = [{
            disabled: false,
            tooltip: this.expired ? 'branded.portal.courses.assignment.external-ebook.launch.tooltip' : null,
            url: course.contents[0].scheduledAssessment.status !== 'Completed' ? course.contents[0].scheduledAssessment.accessUrl : course.contents[0].scheduledAssessment.pdfReport,
            text: course.contents[0].scheduledAssessment.status !== 'Completed' ? 'Start Exam' : 'Download Report',
            type: LinkActions.DOWNLOAD
        }];
        console.log(course)
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/online-exam-card-config.ts